<template>
  <div class="enterprise-solution">
    <!-- 标题区域 -->


    <!-- 内容区域 -->
    <div class="solution-container">
      <div class="solution-content" ref="contentSection" :class="{ 'fade-in': isContentVisible }">
        <!-- 服务流程 -->
        <div class="service-process">
          <h3>服务流程</h3>
          <div class="process-timeline">
            <div class="timeline-item" v-for="(step, index) in serviceProcess" :key="index">
              <div class="timeline-number">{{ index + 1 }}</div>
              <div class="timeline-content">
                <h4>{{ step.title }}</h4>
                <p>{{ step.description }}</p>
              </div>
              <div class="timeline-connector" v-if="index < serviceProcess.length - 1"></div>
            </div>
          </div>
        </div>

        <!-- 服务内容 -->
        <div class="service-content">
          <h3>服务内容</h3>
          <div class="service-tabs">
            <div 
              v-for="(service, index) in services" 
              :key="index"
              class="tab-item"
              :class="{ 'active': activeServiceTab === index }"
              @click="activeServiceTab = index"
            >
              {{ service.title }}
            </div>
          </div>
          <div class="service-details">
            <transition name="fade" mode="out-in">
              <div class="service-detail" :key="activeServiceTab">
                <div class="detail-header">
                  <h4>{{ services[activeServiceTab].title }}</h4>
                </div>
                <div class="detail-content">
                  <p>{{ services[activeServiceTab].description }}</p>
                  <ul class="feature-list">
                    <li v-for="(feature, index) in services[activeServiceTab].features" :key="index">
                      {{ feature }}
                    </li>
                  </ul>
                </div>
              </div>
            </transition>
          </div>
        </div>

        <!-- 服务成效 -->
        <div class="service-results">
          <h3>服务成效</h3>
          <div class="results-grid">
            <div class="result-card" v-for="(result, index) in results" :key="index">
              <div class="result-value">{{ result.value }}</div>
              <div class="result-label">{{ result.label }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const serviceProcess = [
  {
    title: '需求分析',
    description: '深入了解企业业务流程和信息化需求，制定个性化解决方案'
  },
  {
    title: '方案设计',
    description: '根据需求分析结果，设计符合企业实际情况的信息化解决方案'
  },
  {
    title: '系统实施',
    description: '按照方案进行系统部署和实施，确保系统稳定运行'
  },
  {
    title: '培训支持',
    description: '提供系统使用培训和技术支持，确保企业员工能够熟练使用系统'
  },
  {
    title: '运维服务',
    description: '提供长期的运维服务，保障系统的稳定运行和持续优化'
  }
]

const services = [
  {
    title: '综合服务平台',
    description: '针对企业与政务部门需求，提供基于生态的定制化解决方案，推动移动办公与政务服务数字化转型',
    features: [
      '平台搭建与基础配置',
      '应用开发与系统集成',
      '数据管理与智能分析',
      '安全合规与风险管控',
      '移动办公与协作优化',
      '政务服务数字化转型',
      '政务流程与服务监管',
   
    ]
  },
  // {
  //   title: '政务微信服务',
  //   description: '针对政府部门需求，提供专业的政务微信解决方案，助力政务服务数字化转型',
  //   features: [
  //     '政务微信平台规划与建设',
  //     '政务服务应用开发',
  //     '政务数据安全管理',
  //     '政务流程优化',
  //     '政务服务监管'
  //   ]
  // },
  {
    title: '系统集成服务',
    description: '提供各类信息系统的集成服务，实现业务系统的互联互通和数据共享',
    features: [
      '异构系统集成',
      '数据交换与共享',
      '接口开发与管理',
      '流程优化与再造',
      '集成平台建设'
    ]
  },
  {
    title: '运维支持服务',
    description: '提供7*24小时的运维支持服务，确保系统的稳定运行和业务的连续性',
    features: [
      '系统监控与预警',
      '故障诊断与处理',
      '性能优化与调优',
      '安全管理与防护',
      '定期巡检与报告'
    ]
  }
]

const results = [
  { value: '协作效率提升', label: '' },
  { value: '流程处理提速', label: '' },
  { value: '员工满意度提升', label: '' },
  { value: '运营成本降低', label: '' }
]

const activeServiceTab = ref(0)
const isHeaderVisible = ref(false)
const isContentVisible = ref(false)
const headerSection = ref(null)
const contentSection = ref(null)

onMounted(() => {
  // 确保页面从顶部开始显示
  console.log('🏢 企业数字化解决方案组件挂载，确保滚动到顶部')
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
  window.scrollTo(0, 0)

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.target === headerSection.value) {
        isHeaderVisible.value = entry.isIntersecting
      }
      if (entry.target === contentSection.value) {
        isContentVisible.value = entry.isIntersecting
      }
    })
  }, { threshold: 0.2 })

  if (headerSection.value) observer.observe(headerSection.value)
  if (contentSection.value) observer.observe(contentSection.value)

  return () => observer.disconnect()
})
</script>

<style lang="scss" scoped>
.enterprise-solution {
  padding: 40px 0;

  .solution-header {
    text-align: center;
    margin-bottom: 60px;
    opacity: 0;
    transform: translateY(20px);
    transition: all 0.6s ease;

    &.fade-in {
      opacity: 1;
      transform: translateY(0);
    }

    .title-box {
      h1 {
        font-size: 36px;
        color: #333;
        margin-bottom: 16px;
      }

      p {
        font-size: 18px;
        color: #666;
      }
    }
  }

  .solution-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .solution-content {
    opacity: 0;
    transform: translateY(20px);
    transition: all 0.6s ease;

    &.fade-in {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .service-process {
    margin-bottom: 60px;

    h3 {
      font-size: 24px;
      color: #333;
      margin-bottom: 30px;
      text-align: center;
    }

    .process-timeline {
      position: relative;
      max-width: 800px;
      margin: 0 auto;

      .timeline-item {
        display: flex;
        align-items: flex-start;
        margin-bottom: 40px;
        position: relative;

        .timeline-number {
          width: 40px;
          height: 40px;
          background: #2b5dff;
          color: #fff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          font-weight: bold;
          margin-right: 20px;
          flex-shrink: 0;
          position: relative;
          z-index: 2;
        }

        .timeline-content {
          background: #fff;
          padding: 20px 30px;
          border-radius: 10px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
          flex: 1;
          transition: all 0.3s;

          &:hover {
            transform: translateY(-5px);
            box-shadow: 0 8px 20px rgba(0,0,0,0.1);
          }

          h4 {
            font-size: 18px;
            color: #333;
            margin-bottom: 10px;
          }

          p {
            font-size: 14px;
            color: #666;
            line-height: 1.6;
          }
        }

        .timeline-connector {
          position: absolute;
          top: 40px;
          left: 20px;
          width: 2px;
          height: calc(100% + 20px);
          background: #e0e0e0;
          z-index: 1;
        }
      }
    }
  }

  .service-content {
    margin-bottom: 60px;

    h3 {
      font-size: 24px;
      color: #333;
      margin-bottom: 30px;
      text-align: center;
    }

    .service-tabs {
      display: flex;
      justify-content: center;
      margin-bottom: 30px;
      flex-wrap: wrap;
      gap: 10px;

      .tab-item {
        padding: 12px 20px;
        background: #f0f0f0;
        color: #666;
        border-radius: 30px;
        cursor: pointer;
        transition: all 0.3s;
        font-size: 14px;

        &:hover {
          background: #e0e0e0;
        }

        &.active {
          background: #2b5dff;
          color: #fff;
        }
      }
    }

    .service-details {
      background: #fff;
      border-radius: 10px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.05);
      overflow: hidden;

      .service-detail {
        .detail-header {
          background: #2b5dff;
          color: #fff;
          padding: 20px 30px;

          h4 {
            font-size: 20px;
            margin: 0;
          }
        }

        .detail-content {
          padding: 30px;

          p {
            font-size: 16px;
            color: #666;
            line-height: 1.8;
            margin-bottom: 20px;
          }

          .feature-list {
            list-style: none;
            padding: 0;
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
            gap: 15px;

            li {
              font-size: 14px;
              color: #666;
              padding-left: 20px;
              position: relative;

              &:before {
                content: '';
                position: absolute;
                left: 0;
                top: 8px;
                width: 6px;
                height: 6px;
                background: #2b5dff;
                border-radius: 50%;
              }
            }
          }
        }
      }
    }
  }

  .service-results {
    h3 {
      font-size: 24px;
      color: #333;
      margin-bottom: 30px;
      text-align: center;
    }

    .results-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      gap: 30px;

      .result-card {
        background: #fff;
        padding: 30px;
        border-radius: 10px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.05);
        text-align: center;
        transition: all 0.3s;

        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 20px rgba(0,0,0,0.1);
          background: #2b5dff;

          .result-value {
            color: #fff;
          }
        }

        .result-value {
          font-size: 18px;
          font-weight: bold;
          color: #2b5dff;
          margin-bottom: 0;
          transition: all 0.3s;
        }

        .result-label {
          display: none;
        }
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@media (max-width: 768px) {
  .enterprise-solution {
    padding: 20px 0;

    .process-timeline {
      .timeline-item {
        flex-direction: column;
        
        .timeline-number {
          margin-bottom: 15px;
        }
        
        .timeline-connector {
          display: none;
        }
      }
    }

    .service-tabs {
      .tab-item {
        flex: 1 0 calc(50% - 10px);
        text-align: center;
      }
    }

    .feature-list {
      grid-template-columns: 1fr !important;
    }

    .results-grid {
      grid-template-columns: 1fr !important;
    }
  }
}
</style> 